import React from 'react'
import styles from './Gt2ShopMarketing.module.css'
import ComparisonTable from '../../ComparisonTable'

// Marketing blocks shown BELOW the GT-2 buy box on the shop/configurator page
// (freed up by the compact main+thumbnail gallery). Surfaces the proof the thin
// shop page was missing: the spec proof band, a pro-pedigree band and the
// best-quality feature rows. Static presentational content; no client state.
// Copy pending sign-off (see the legal notes in rows.js / Gt2Compatibility).

const PROOF = [
  { label: '45 Nm-ready', sub: 'Built for modern direct drive bases' },
  { label: 'Sliders + brackets included', sub: 'Fast, hassle-free seat installation' },
  { label: '95% pre-assembled', sub: 'Bolt in your gear and race' },
  { label: 'Made in the EU', sub: '160 x 40 mm heavy-gauge aluminum' },
  { label: '3-year warranty', sub: 'On VRS manufactured components' },
]

function Check() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

function Gt2ShopMarketing() {
  return (
    <section className={styles.wrap} aria-label="Why the GT-2">
      <div className={styles.inner}>

        {/* Proof band REMOVED in the redesign. It said the same five things as
            the spec strip in the buy box (45 Nm, alu profile, 95% pre-assembled,
            EU, warranty), 300px lower and with five more red check marks. One
            fact, one place. PROOF is kept below so the copy is not lost if this
            band comes back somewhere it does not compete. */}

        {/* Same comparison table as /hardware/gt2-cockpit, in the slot the
            pedigree band used to occupy. */}
        <ComparisonTable/>

        {/* The alternating feature rows used to sit here, inside the left column.
            They are now rendered full width from index.js, under the two-column
            block, so the photos are not boxed into the column. */}

        {/* Reviews section hidden for now (no independent reviews seeded yet). */}

      </div>
    </section>
  )
}

// Pro-pedigree band. Lives OUTSIDE Gt2ShopMarketing so the configurator can place
// it directly above the compatibility section.
export function Gt2Pedigree() {
  return (
    <section className={`${styles.wrap} ${styles.wrapFull}`} aria-label="The cockpit the pros race on">
      <div className={styles.inner}>
        <div className={styles.pedigree}>
          <span className={styles.pedigreeEyebrow}>The cockpit the pros race on</span>
          <h3 className={styles.pedigreeTitle}>Built for, and proven by, professional teams</h3>
          <p className={styles.pedigreeText}>
            Apex Racing trains and competes on VRS DirectForce rigs. The GT-2 is the same platform, engineered in the EU to stay dead rigid lap after lap.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Gt2ShopMarketing
